/** @format **/

import { generateScreen } from "./generator";

const verifyScreens = (i18n) => ({
  methodsIntro: {
    type: "verify-intro",
    params: {
      screenTitle: (store) => i18n.t("specifics:legal.identity-verification"),
    },
  },
});

export const getVerifyScreens = generateScreen.bind(null, verifyScreens);



// WEBPACK FOOTER //
// ./src/partners/config/screens/verify.js